export const capitalizeFirstLetter = (str?: string): string => {
  if (typeof str !== 'string' || str.length === 0) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const enumToTitle = (str?: string): string => {
  if (typeof str !== 'string' || str.length === 0) return '';
  return str
    .replace(/_/g, ' ')
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const stringToColor = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `#${((hash >> 24) & 0xff).toString(16).padStart(2, '0')}${(
    (hash >> 16) &
    0xff
  )
    .toString(16)
    .padStart(2, '0')}${((hash >> 8) & 0xff).toString(16).padStart(2, '0')}`;
  return color;
};

export const calculateTimeToExpire = (expiration: number): number => {
  const currentTimestamp = Math.floor(Date.now() / 1000);
  return (expiration - currentTimestamp) * 1000;
};
